export enum DigestAlgorithm {
  MD2 = 'MD2',
  MD5 = 'MD5',
  SHA_1 = 'SHA_1',
  SHA_224 = 'SHA_224',
  SHA_256 = 'SHA_256',
  SHA_384 = 'SHA_384',
  SHA_512 = 'SHA_512',
  SHAKE_128 = 'SHAKE_128',
  SHAKE_256 = 'SHAKE_256',
}
